<script setup lang="ts">
const { target = "sidebar-filter" } = defineProps<{
  target?: string;
}>();
</script>

<template>
  <button
    class="btn btn-sm btn-light shadow-sm rounded-3 d-lg-none d-flex gap-1 align-items-center"
    type="button"
    data-bs-toggle="offcanvas"
    :data-bs-target="`#${target}`"
    :aria-controls="target"
    aria-label="Åbn filter"
  >
    <i class="bi bi-filter fs-4"></i> Filter
  </button>
</template>
